"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDatePicker = exports.calculateNewOffset = void 0;
var dayzed_1 = require("dayzed");
var react_1 = require("react");
var shared_1 = require("./shared");
var isClearingDateRange = function (selectedDates, newDate) {
    var _a, _b;
    return ((_a = selectedDates[0]) === null || _a === void 0 ? void 0 : _a.getTime()) === newDate.getTime() || ((_b = selectedDates[1]) === null || _b === void 0 ? void 0 : _b.getTime()) === newDate.getTime();
};
var calculateNewOffset = function (selectedDates, newDate, initialDate, currentOffset) {
    var currentEndDate = selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.slice(-1).pop();
    var shouldClearDateRange = isClearingDateRange(selectedDates, newDate);
    var dateToCalculateOffsetFrom = currentEndDate && !shouldClearDateRange ? currentEndDate : initialDate;
    if (!dateToCalculateOffsetFrom) {
        return currentOffset;
    }
    var monthDiff = dateToCalculateOffsetFrom.getMonth() -
        newDate.getMonth() +
        12 * (dateToCalculateOffsetFrom.getFullYear() - newDate.getFullYear());
    return currentOffset + monthDiff * (shouldClearDateRange ? -1 : 1);
};
exports.calculateNewOffset = calculateNewOffset;
var useDatePicker = function (_a) {
    var date = _a.date, minDate = _a.minDate, maxDate = _a.maxDate, monthsToDisplay = _a.monthsToDisplay, selected = _a.selected, onDateSelected = _a.onDateSelected;
    var calculatedOffset = -((monthsToDisplay || 1) - 1);
    var _b = (0, react_1.useState)(calculatedOffset), offset = _b[0], setOffset = _b[1];
    var _c = (0, react_1.useState)(), hoveredDate = _c[0], setHoveredDate = _c[1];
    var onOffsetChanged = (0, react_1.useCallback)(function (newOffset) {
        setOffset(newOffset);
    }, []);
    var _d = (0, dayzed_1.useDayzed)({
        date: date,
        minDate: minDate ? (0, shared_1.getDateFromDateOrNow)(minDate) : undefined,
        maxDate: maxDate ? (0, shared_1.getDateFromDateOrNow)(maxDate) : undefined,
        monthsToDisplay: monthsToDisplay,
        offset: offset,
        onOffsetChanged: onOffsetChanged,
        selected: selected,
        onDateSelected: function (newDate) {
            // reset the offset if a new end date is selected because they are linked in Dayzed mind
            setOffset(function (currentOffset) { return (0, exports.calculateNewOffset)(selected, newDate.date, date || new Date(), currentOffset); });
            onDateSelected(newDate);
        },
    }), calendars = _d.calendars, getDateProps = _d.getDateProps, getBackProps = _d.getBackProps, getForwardProps = _d.getForwardProps;
    var onDateMouseOver = function (_a) {
        var dateWithMouseEnter = _a.date, isSelectable = _a.selectable;
        setHoveredDate(isSelectable ? dateWithMouseEnter : undefined);
    };
    var onDateMouseOut = (0, react_1.useCallback)(function (_a) {
        var dateWithMouseLeave = _a.date;
        if (hoveredDate && hoveredDate.getTime() === dateWithMouseLeave.getTime()) {
            setHoveredDate(undefined);
        }
    }, [hoveredDate]);
    return {
        calendars: calendars,
        getDateProps: getDateProps,
        getBackProps: getBackProps,
        getForwardProps: getForwardProps,
        hoveredDate: hoveredDate,
        onDateMouseOver: onDateMouseOver,
        onDateMouseOut: onDateMouseOut,
    };
};
exports.useDatePicker = useDatePicker;
